import React, { useEffect } from "react";
import "./ReviewWidget.scss";

const ReviewWidget = ({ type = "chelsea", title = "What Our Clients Say", className = "" }) => {

  useEffect(() => {
    // Prevent duplicate script loading
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement("script");
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  // Elfsight widget IDs
  const widgetIds = {
    chelsea: "aede41d5-eae6-4afd-ac3f-e4cb3457d741",
    kensington: "9e78bcdb-2852-47d3-971b-a1037380127a",
  };

  const widgetId = widgetIds[type] || widgetIds.chelsea;

  return (
    <section className={`review-widget-section ${className}`}>
      <div className="container">
        {title && (
          <h2 className="review-widget-title">
            {title}
          </h2>
        )}

        <div
          className={`elfsight-app-${widgetId}`}
          data-elfsight-app-lazy
        ></div>
      </div>
    </section>
  );
};

export default ReviewWidget;